module.exports = __webpack_public_path__ + "img/header-engagementRingsCharacter@2x.2288dfb.jpg";